import React, { useContext } from 'react'
import SectionTitle from '../../ui/SectionTitle/SectionTitle'
import './About.sass'
import Button from '../../ui/Button/Button'
import bgImage from './groupimg.svg'
import { AuthContext } from '../../App'
import Icon from '../../ui/Icon/Icon'

function About() {
  const { contacts, setShowContactUs } = useContext(AuthContext)

  const benefits = [
    {
      title: 'Большой номерной фонд',
      description: `Номера эконом, стандарт и семейного класса`,
      icon: 'hotel',
    },
    {
      title: 'Бесплатный трансфер',
      description: `с ж/д вокзала, а также встреча с аэропорта, по договоренности`,
      icon: 'bus',
    },
    {
      title: 'Организация питания',
      description: `Согласно нашего специального меню`,
      icon: 'soup',
    },
    {
      title: 'Работаем по договору',
      description: `Удобная оплата наличным и безналичным способом, гарантия оперативного предоставления отчетных документов`,
      icon: 'file-invoice',
    },
  ]

  return (
    <section id="group" name="group" class="About">
      <div className="DefaultContainer">
        <SectionTitle title="Групповое размещение" />
        <div class="About-Container">
          <div class="About-Text">
            <p>
              Готовы предоставить услугу группового размещения. Организуем
              бесплатный трансфер с ж/д вокзала, а также встретим с аэропорта,
              по предварительной договоренности. Предоставим выгодные условия
              проживания. Дополнительно возможна организация питания согласно
              нашего специального меню.
            </p>
            <div className="Benefits-Container">
              {benefits.map((b) => (
                <div className="BenefitTile">
                  <Icon name={b.icon} weight="regular" />
                  <div className="Text">
                    <p className="Title">{b.title}</p>
                    <p className="Description">{b.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <Button
              title="Заказать обратный звонок"
              type="button"
              icon="phone"
              iconWeight="solid"
              onClick={() =>
                setShowContactUs({
                  show: true,
                  title: 'Заказать обратный звонок',
                  emailSubject: 'Запрос на консультацию',
                })
              }
              // onClick={() => (window.location.href = `tel:${contacts.phone}`)}
            />
          </div>
          <div className="AboutImg">
            <img src={bgImage} alt="Gusto" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
